import { render, staticRenderFns } from "./vehicleInfo.vue?vue&type=template&id=22901deb&scoped=true"
import script from "./vehicleInfo.vue?vue&type=script&lang=js"
export * from "./vehicleInfo.vue?vue&type=script&lang=js"
import style0 from "./vehicleInfo.vue?vue&type=style&index=0&id=22901deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22901deb",
  null
  
)

export default component.exports